import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Quint, TweenMax} from 'gsap';
import {SharedService} from '../shared.service';
import {AppEventDispatcher} from '../../utils/AppEventDispatcher';
import {EventTypes} from '../EventTypes';
import * as printJS from 'print-js';
import {
	TransactionHandlerService
} from '../../master/transfers-other-banks/transfer-response/services/transaction-handler.service';
import {ExtractService} from '../../master/extract/extract.service';
import * as FileSaver from 'file-saver';
import {ResponseModel} from './response.model';
import {BankExtract} from "../../master/extract/extract.model";
import {Util} from "../../utils/util";
import * as moment from "moment";
import { saveAs } from 'file-saver';
@Component({
	selector: 'app-export-buttons',
	templateUrl: './export-buttons.component.html',
	styleUrls: ['./export-buttons.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ExportButtonsComponent implements OnInit {

	constructor(
		private extractService: ExtractService,
		private sharedService: SharedService,
		private transactionHandlerService: TransactionHandlerService
	) {
	}

	@Input() sendEmail = false;
	@Input() sendEmailUserLogged = false;
	@Input() sendExtractEmail = false;
	@Input() printExtract = false;
	@Input() printReceipt = false;
	@Input() printBankSlip = false;
	@Input() printAdhesion = false;
	@Input() printReportIncome = false;
	@Input() downloadExcel = false;
	@Input() downloadPdf = false;
	@Input() downloadExtractPdf = false;
	@Input() downloadBankSlipPdf = false;
	@Input() downloadPdfAdhesion = false;
	@Input() downloadReportIncomePdf = false;
	@Input() twoButtons = false;
	@Input() threeButtons = false;
	@Input() fourButtons = false;
	@Input() pdfName: string;
	@Input() returnInit: false;
	@Input() isCipPayment: false;
	@Input() dataInicio: Date;
	@Input() dataFim: Date;

	public transferNumber: number;
	public receiptType: string;
	public numberBankSlip: string;
	public yearReportIncome: string;
	public open = true;
	public send = false;
	public error = false;
	public success = false;
	public extract = false;
	public bankSlip = false;
	public descDocument: string;
	public desiredEmail: string;
	public toCallPdf = true;
	public dateBegin: any;
	public dateEnd: any;
	public toCallPrint = true;

	ngOnInit() {
		AppEventDispatcher.listen(EventTypes.EXPORT_BUTTONS.DATA_TRANSACTION, data => {
			this.transferNumber = data.transferNumber;
			this.receiptType = data.receiptType;
			this.numberBankSlip = data.numberBankSlip;
		});

		AppEventDispatcher.listen(EventTypes.EXPORT_BUTTONS.DATA_REPORT_INCOME, data => {
			this.yearReportIncome = data.yearReportIncome;
		});

		this.descDocument = (this.sendExtractEmail || this.downloadExtractPdf ? 'extrato' : (this.downloadBankSlipPdf ? 'boleto' : (this.downloadReportIncomePdf ? 'documento' : 'comprovante')));
	}

	downloadExcelFile() {
		this.sharedService.downloadFile(this.transferNumber, this.receiptType, 'Excel').subscribe(
			data => {
			},
			error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});
			}
		);
	}

	isIE() {
		const ua = navigator.userAgent;
		/* MSIE used to detect old browsers and Trident used to newer ones*/
		const is_ie = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1;

		return is_ie;
	}

	isFirefox() {
		const ua = navigator.userAgent;
		const is_firefox = ua.toLowerCase().indexOf('firefox') > -1;

		return is_firefox;

	}

	isEdge() {
		const ua = navigator.userAgent;
		const is_edge = ua.toLowerCase().includes('edge');

		return is_edge;
	}

	downloadPdfFile() {

		if (this.toCallPdf) {

			this.toCallPdf = false;

			this.sharedService.downloadFile(this.transferNumber, this.receiptType, 'PDF').subscribe(
				data => {
					const linkSource = `data:application/pdf;base64,${data}`;
					const downloadLink = document.createElement('a');
					const fileName = this.pdfName;

					const byteCharacters = atob(data);

					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);

					const blob = new Blob([byteArray], {type: 'application/pdf'});

					if (this.isIE()) {
						window.navigator.msSaveOrOpenBlob(blob);
					} else if (this.isFirefox()) {
						downloadLink.href = linkSource;
						downloadLink.download = 'Comprovante.pdf';
						downloadLink.setAttribute('type', 'hidden'); // make it hidden if needed
						document.body.appendChild(downloadLink);
						// adiciona target: _blank para abrir em uma nova aba
						downloadLink.setAttribute('target', '_blank');
						downloadLink.click();
						downloadLink.remove();
					} else if (this.isEdge()) {
						window.navigator.msSaveOrOpenBlob(blob, 'Comprovante.pdf');
					} else {
						downloadLink.href = linkSource;
						downloadLink.download = fileName;
						downloadLink.click();
					}

					this.toCallPdf = true;
				},
				error => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});

					this.toCallPdf = true;
				}
			);
		}
	}

	downloadExtractPdfFile() {
		if (this.toCallPdf) {

			this.toCallPdf = false;

			this.sharedService.downloadExtractFile(this.dateBegin, this.dateEnd, 'PDF').subscribe(
				data => {
					const linkSource = `data:application/pdf;base64,${data}`;
					const downloadLink = document.createElement('a');
					const fileName = this.pdfName;

					const byteCharacters = atob(data);

					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);

					const blob = new Blob([byteArray], {type: 'application/pdf'});
					const blobObject = new Blob([data], {type: 'application/pdf'});


					if (this.isIE()) {
						window.navigator.msSaveOrOpenBlob(blob);
					} else if (this.isFirefox()) {
						downloadLink.href = linkSource;
						downloadLink.download = 'Extrato.pdf';
						// downloadLink.setAttribute('type', 'hidden'); // make it hidden if needed
						document.body.appendChild(downloadLink);
						// adiciona target: _blank para abrir em uma nova aba
						downloadLink.setAttribute('target', '_blank');
						downloadLink.click();
						// downloadLink.remove();
					} else if (this.isEdge()) {
						window.navigator.msSaveOrOpenBlob(blob, 'Extrato.pdf');
					} else {
						downloadLink.href = linkSource;
						downloadLink.download = fileName;
						downloadLink.click();
					}
					this.toCallPdf = true;
				},
				error => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});

					this.toCallPdf = true;
				}
			);
		}
	}

	downloadPdfBankSlip() {

		if (this.toCallPdf) {

			this.toCallPdf = false;

			const params = {
				NumeroTitulo: this.numberBankSlip
			};

			this.sharedService.getBankSlip(params).subscribe(
				data => {
					const linkSource = `data:application/pdf;base64,${data}`;
					const downloadLink = document.createElement('a');
					const fileName = this.pdfName;

					const byteCharacters = atob(data);

					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);

					const blob = new Blob([byteArray], {type: 'application/pdf'});

					if (this.isIE()) {
						window.navigator.msSaveOrOpenBlob(blob);
					} else if (this.isFirefox()) {
						downloadLink.href = linkSource;
						downloadLink.download = 'Boleto de Depósito por Boleto Omni.pdf';
						downloadLink.setAttribute('type', 'hidden'); // make it hidden if needed
						document.body.appendChild(downloadLink);
						// adiciona target: _blank para abrir em uma nova aba
						downloadLink.setAttribute('target', '_blank');
						downloadLink.click();
						downloadLink.remove();
					} else if (this.isEdge()) {
						window.navigator.msSaveOrOpenBlob(blob, 'Boleto de Depósito por Boleto Omni.pdf');
					} else {
						downloadLink.href = linkSource;
						downloadLink.download = fileName;
						downloadLink.click();
					}

					this.toCallPdf = true;
				},
				error => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});

					this.toCallPdf = true;
				}
			);
		}
	}

	downloadPdfReportIncome() {

		if (this.toCallPdf) {

			this.toCallPdf = false;

			const params = {
				ano: this.yearReportIncome
			};

			this.sharedService.getReportIncome(params).subscribe(
				data => {
					const linkSource = `data:application/pdf;base64,${data}`;
					const downloadLink = document.createElement('a');
					const fileName = this.pdfName;

					const byteCharacters = atob(data);

					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);

					const blob = new Blob([byteArray], {type: 'application/pdf'});

					if (this.isIE()) {
						window.navigator.msSaveOrOpenBlob(blob);
					} else if (this.isFirefox()) {
						downloadLink.href = linkSource;
						downloadLink.download = this.pdfName + '.pdf';
						downloadLink.setAttribute('type', 'hidden'); // make it hidden if needed
						document.body.appendChild(downloadLink);
						// adiciona target: _blank para abrir em uma nova aba
						downloadLink.setAttribute('target', '_blank');
						downloadLink.click();
						downloadLink.remove();
					} else if (this.isEdge()) {
						window.navigator.msSaveOrOpenBlob(blob, this.pdfName + '.pdf');
					} else {
						// window.navigator.msSaveOrOpenBlob(blob, this.pdfName + '.pdf');
						// downloadLink.href = linkSource;
						// downloadLink.download = fileName;
						// downloadLink.click();
						const link = document.createElement('a');
						link.setAttribute('href', URL.createObjectURL(blob));
						link.setAttribute('download', fileName);
						const event = new MouseEvent('click');
						link.dispatchEvent(event);
					}

					this.toCallPdf = true;

					if (this.returnInit) {
						this.sharedService.changeRerender(true);
					}
				},
				error => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});

					this.toCallPdf = true;
				}
			);
		}
	}

	emailValidation(validEmail) {
		if (validEmail) {
			this.sendToEmail();
		}
	}

	emailValidationOnEnter(event, validEmail) {
		if (validEmail && event.keyCode === 13) {
			this.sendToEmail();
		}
	}

	toggleTooltip(open) {
		if (open) {
			this.open = false;
			TweenMax.to('.tooltip-email', .8, {autoAlpha: 1, bottom: 60, ease: Quint.easeOut});
			if (this.sendEmailUserLogged) {
				this.sendToEmail(true);
			}
		} else {
			this.open = true;
			this.desiredEmail = '';
			TweenMax.to('.tooltip-email', .8, {autoAlpha: 0, bottom: 30, ease: Quint.easeOut});
		}
	}

	sendToEmail(myEmail: boolean = false) {
		this.send = true;
		if (this.numberBankSlip) {
			const params = {
				NumeroTitulo: this.numberBankSlip,
				EmailDestinatario: myEmail ? null : this.desiredEmail
			};
			this.sharedService.sendBankSlip(params).subscribe(
				data => {
					this.success = true;
				},
				error => {
					this.error = true;
				}
			);
		} else if (this.sendExtractEmail) {
			this.sharedService.sendExtractReceiptsToEmail(this.dateBegin, this.dateEnd, 'PDF', myEmail ? null : this.desiredEmail).subscribe(
				data => {
					this.success = true;
				},
				error => {
					this.error = true;
				}
			);
		} else if (this.yearReportIncome) {
			this.sharedService.sendReportIncomeToEmail(this.yearReportIncome, myEmail ? null : this.desiredEmail).subscribe(
				data => {
					this.success = true;
					setTimeout(() => {
						if (this.returnInit) {
							this.sharedService.changeRerender(true);
						}
					}, 10000);
				},
				error => {
					this.error = true;
				}
			);
		} else {
			this.sharedService.sendReceiptsToEmail(this.transferNumber, this.receiptType, 'PDF', myEmail ? null : this.desiredEmail).subscribe(
				data => {
					this.success = true;
				},
				error => {
					this.error = true;
				}
			);
		}
	}

	closeTooltip() {
		TweenMax.to('.tooltip-email', .8, {
			autoAlpha: 0, bottom: 30, ease: Quint.easeOut, onComplete: () => {
				this.send = false;
				this.success = false;
				this.error = false;
				this.open = true;
			}
		});
	}

	printPdfExtract() {
		this.toCallPrint = false;
		this.sharedService.downloadExtractFile(this.dateBegin, this.dateEnd, 'PDF').subscribe(
			data => {
				this.toCallPrint = true;
				printJS({printable: data, type: 'pdf', base64: true});
			});
	}

	printPdfBankSlip() {
		this.toCallPrint = false;
		const params = {
			NumeroTitulo: this.numberBankSlip
		};
		this.sharedService.getBankSlip(params).subscribe(
			data => {
				this.toCallPrint = true;
				printJS({printable: data, type: 'pdf', base64: true});
			});
	}

	printPdfReportIncome() {
		this.toCallPrint = false;
		const params = {
			ano: this.yearReportIncome
		};
		this.sharedService.getReportIncome(params).subscribe(
			data => {
				this.toCallPrint = true;
				printJS({printable: data, type: 'pdf', base64: true});


				if (this.returnInit) {
					this.sharedService.changeRerender(true);
				}
			});
	}

	printPdfReceipt() {
		this.toCallPrint = false;
		this.sharedService.downloadFile(this.transferNumber, this.receiptType, 'PDF').subscribe(
			data => {
				this.toCallPrint = true;
				printJS({printable: data, type: 'pdf', base64: true});
			});
	}

	printPdfAdhesion() {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'Erro ao gerar PDF'});

		this.toCallPdf = true;
	}

	downloadPdfAdhesionFile() {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'Erro ao gerar PDF'});

		this.toCallPdf = true;
	}


	downloadCsvFile() {
		const beginDate = moment(this.dataInicio).format('YYYYMMDD');
		const endDate = this.dataFim ? moment(this.dataFim).format('YYYYMMDD') : null;

		this.extractService.getNewExtract(beginDate, endDate, true)
			.subscribe(result => {
				let res: ResponseModel[] = []
				let obj: BankExtract = Util.keysToCamel(result.Retorno) as BankExtract;
				obj.transacoes.forEach(c => {
					res.push(
						new ResponseModel(
							c.dataTransacao,
							c.descricaoHistorico,
							c.codigoDocumento,
							c.valor.toString().replace('.', ','),
							c.saldo.toString().replace('.', ',')
						)
					)
				})
				const csvData = this.convertToCSV(res);
				const blob = new Blob([csvData], {type: 'text/csv;charset=utf-8'});
				FileSaver.saveAs(blob, `Extrato_613_${beginDate}_a_${endDate}.csv`);
			});
	}

	convertToCSV(jsonData: any[]) {
		const headers = Object.keys(jsonData[0]);
		const rows = jsonData.map(row => headers.map(fieldName => JSON.stringify(row[fieldName])).join(';'));
		return headers.join(';') + '\n' + rows.join('\n');
	}

	downloadDataAsOfx() {
		const beginDate = moment(this.dataInicio).format('YYYYMMDD');
		const endDate = this.dataFim ? moment(this.dataFim).format('YYYYMMDD') : null;

		this.extractService.getNewExtract(beginDate, endDate, true)
			.subscribe(result => {
				let res: ResponseModel[] = []
				let obj: BankExtract = Util.keysToCamel(result.Retorno) as BankExtract;
				obj.transacoes.forEach(c => {
					res.push(
						new ResponseModel(
							c.dataTransacao,
							c.descricaoHistorico,
							c.codigoDocumento,
							c.valor.toString().replace('.', ','),
							c.saldo.toString().replace('.', ',')
						)
					)
				})
				const ofxContent = this.buildOfxContent(res);

				// Criar um Blob e baixar o arquivo OFX
				const fileBlob = new Blob([ofxContent], {type: 'application/octet-stream'});
				saveAs(fileBlob, 'extrato.ofx');

			});
	}

	private buildOfxContent(transactions: ResponseModel[]): string {
		const header = `OFXHEADER:100\nDATA:${new Date().toISOString()}\nVERSION:102\nSECURITY:NONE\nENCODING:USASCII\nCHARSET:1252\nCOMPRESSION:NONE\nOLDFILEUID:NONE\nNEWFILEUID:NONE\n`;
		let dataAtual = new Date();
		let ano = dataAtual.getFullYear().toString();
		let mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2);
		let dia = ('0' + dataAtual.getDate()).slice(-2);
		const dataServer: string = ano + mes + dia;
		const transactionBody = transactions.map(transaction => {

			console.log(transaction.dataTransacao)

			const formattedDate = transaction.dataTransacao ;
			const transactionAmount = parseFloat(transaction.valor.replace(',', '.'));

			return `<STMTTRN>\n<TRNTYPE>DEBIT\n<DTPOSTED>${formattedDate}\n<TRNAMT>${transactionAmount}\n<MEMO>${transaction.descricao}\n</STMTTRN>\n`;
		}).join('');

		const ofxString = `${header}\n<OFX>\n<SIGNONMSGSRSV1>\n<SONRS>\n<STATUS>\n<CODE>0</CODE>\n<SEVERITY>INFO</SEVERITY>\n</STATUS>\n</SONRS>\n</SIGNONMSGSRSV1>\n<BANKMSGSRSV1>\n<DTSERVER>${dataServer}</DTSERVER>\n<LANGUAGE>POR</LANGUAGE>\n${transactionBody}</BANKMSGSRSV1>\n</OFX>`;

		return ofxString;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/export-buttons/export-buttons.component.ts